module.exports = __webpack_public_path__ + "static/media/invite.0cb9eb1b.png";